import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import AppWrapper from "../Common/AppWrapper/index.jsx";
import Loading from "../Common/Misc/Loading.jsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import * as assayActions from "../../actions/assays.js";
import * as cartActions from "../../actions/addToCart.js";
import PropTypes from "prop-types";
import { MyAssayRow } from "./MyAssayRow.jsx";
import MyAssayToggle from "./MyAssayToggle.jsx";
import TablePagination from "@material-ui/core/TablePagination";
import "./MyAssays.scss";
import Tooltip from "@material-ui/core/Tooltip";
import { formatDateTime, getSorting } from "../../util/format";
import classNames from "classnames";

export const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(2),
    overflowX: "auto",
  },
  progress: {
    margin: theme.spacing(2),
  },
  select: {
    color: "#0a963f",
  },
  menuItem: {
    color: "#0a963f",
  },
});

export class EnhancedTableHead extends Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, columnData } = this.props;
    return (
      <TableHead>
        <TableRow>
          {columnData.map((column) => {
            return (
              <TableCell
                key={column.id}
                className={(column.label === "" && "tubeFormat") || ""}
                padding="none"
                sortDirection={orderBy === column.id ? order : false}
              >
                {column.label !== "" && (
                  <Tooltip
                    title="Sort"
                    placement={column.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={this.createSortHandler(column.id)}
                    >
                      {column.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
          <TableCell>{""} </TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

class PendingAssays extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayDetails: false,
    };
  }

  handleDisplayDetails(e) {
    e.preventDefault();
    const { displayDetails } = this.state;
    this.setState({ displayDetails: !displayDetails });
  }

  render() {
    const { displayDetails } = this.state;
    const { pendingAssays, classes } = this.props;
    const processedMsg =
      pendingAssays && pendingAssays.length === 1
        ? " assay is being processed"
        : " assays are being processed";
    return (
      <div id="pending">
        <h3>Pending Assays</h3>
        <hr />
        {pendingAssays && (
          <div>
            <div className="row align-items-center">
              <div className="col-1">
                <CircularProgress
                  className={classes.progress}
                  size={20}
                  thickness={4}
                />
              </div>
              <div className="col-3">
                {_.size(pendingAssays)} {processedMsg}
              </div>
              <div className="col text-center">
                <a href="" onClick={(e) => this.handleDisplayDetails(e)}>
                  {!displayDetails && (
                    <span>
                      See Details <i className="fas fa-angle-down" />
                    </span>
                  )}
                  {displayDetails && (
                    <span>
                      Hide Details <i className="fas fa-angle-up" />
                    </span>
                  )}
                </a>
              </div>
            </div>

            {displayDetails &&
              pendingAssays &&
              pendingAssays.map((assay) => {
                return (
                  <div key={assay.id} className="row">
                    <div className="col">
                      <div className="alert alert-light" role="alert">
                        {assay.targetName} submitted on{" "}
                        {formatDateTime(assay.createdAt)}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
        <hr />
      </div>
    );
  }
}

class MyAssaysForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      havePendingAssays: false,
      time: Date.now(),
      order: "asc",
      orderBy: "createdAt",
      page: 0,
      rowsPerPage: 20,
      assays: {},
    };
  }

  componentDidMount() {
    this.handleFetchAssays();
    this.setState({
      assays: this.props.assays,
    });
  }

  static getDerivedStateFromProps(nextProps, currState) {
    const pendingAssays =
      (nextProps &&
        nextProps.assays &&
        nextProps.assays.incomplete &&
        !_.isEmpty(nextProps.assays.incomplete)) ||
      false;

    if (pendingAssays) {
      return { havePendingAssays: true };
    } else {
      return { havePendingAssays: false };
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.havePendingAssays !== this.state.havePendingAssays) {
      if (this.state.havePendingAssays) {
        //start timer
        this.timer = setInterval(() => {
          this.handleFetchAssays();
        }, 20000);
      } else {
        //stop timer
        clearInterval(this.timer);
      }
    }
  }

  handleFetchAssays() {
    const { actions } = this.props;
    actions.fetchUserAssays();
    this.setState({ time: Date.now() });
  }

  componentWillUnmount() {
    const { actions } = this.props;
    actions.clearMessage();
    clearInterval(this.timer);
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy });
  };

  render() {
    // Need to change the logic for undesignable and not found
    // const assays = myAssayData.data;
    // // console.log(assays,"assays");
    const columnData = [
      {
        id: "assayFormat",
        numeric: false,
        label: "",
      },
      {
        id: "assayName",
        numeric: false,
        label: "Assay Name",
      },
      {
        id: "targetName",
        numeric: false,
        label: "Target Name",
      },
      {
        id: "createdAt",
        numeric: false,
        label: "Date & Time",
      },
      {
        id: "applicationType",
        numeric: false,
        label: "Assay Type",
      },
      {
        id: "status",
        numeric: false,
        label: "Status",
      },
      {
        id: "validationType",
        numeric: false,
        label: "Wet Lab Validated",
      },
      {
        id: "chemistry",
        numeric: false,
        label: "Chemistry",
      },
      {
        id: "dyes",
        numeric: false,
        label: "Probe Fluorophore(s)",
      },
      {
        id: "assayId",
        numeric: false,
        label: "ID",
      },
    ];
    const { classes, assays, apiStatus, assayDetail, pageLoading } = this.props;
    const { order, orderBy, rowsPerPage, page } = this.state;
    const processingAssays = (assays && assays.incomplete) || [];
    const completedAssays = (assays && assays.complete) || [];

    if (pageLoading) {
      return <Loading isLoading={pageLoading} />;
    }

    const userHasAssays = assays && (completedAssays || processingAssays);

    if (_.isEmpty(userHasAssays) && apiStatus === 200) {
      return (
        <div className="alert alert-danger text-center" role="alert">
          Click Get a New Assay to get started or select Assays (excluding Gene
          Expression) to see all other assays in your design history. 
        </div>
      );
    }

    const pendingAssays =
      (assays && processingAssays.length && processingAssays) || false;

    return (
      <div>
        {pendingAssays && (
          <PendingAssays {...this.props} pendingAssays={processingAssays} />
        )}

        <h3>Completed Assays</h3>
        <div className="assay-results">
          <Paper className={classes.root}>
            <Table className={classes.table}>
              <EnhancedTableHead
                className={classNames("assay-results")}
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
                columnData={columnData}
              />

              {assays &&
              completedAssays && ( // EDIT: CSS fix needed.
                  <TableBody>
                    {completedAssays &&
                      !_.isEmpty(completedAssays) &&
                      [...completedAssays]
                        .sort(getSorting(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          return (
                            <MyAssayRow
                              key={index}
                              row={row}
                              evenOddClass={index % 2 ? "even" : "odd"}
                              assayDetail={assayDetail}
                              {...this.props}
                            />
                          );
                        })}
                  </TableBody>
                )}
            </Table>
            <TablePagination
              className={classNames(
                classes.select,
                classes.menuItem,
                "table-pagination"
              )}
              component="div"
              count={completedAssays.length}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[10, 20, 50, 75]}
              page={page}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    );
  }
}

const stateToProps = (state) => ({
  assays:
    (state.assays &&
      state.assays.cache &&
      state.assays.cache.data &&
      state.assays.cache.data.data) ||
    [],
  pageLoading: (state.assays && state.assays.pageLoading) || false,
  assayDetail: (state.assays && state.assays.detail) || {},
  apiStatus:
    (state.assays &&
      state.assays.cache &&
      state.assays &&
      state.assays.cache.status) ||
    "",
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    Object.assign({}, cartActions, assayActions),
    dispatch
  ),
});

MyAssaysForm = withStyles(styles)(MyAssaysForm);

MyAssaysForm = connect(stateToProps, dispatchToProps)(MyAssaysForm);

class AssayMenu extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div>
        <button
          id="get-new-assay-btn"
          type="button"
          className="rounded outline dropdown-toggle"
          aria-owns={anchorEl ? "simple-menu" : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          Get a New Assay <span className="caret" />
        </button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <Link to="/digital-assays/assays-create/mutation">
            <MenuItem onClick={this.handleClose}>Mutation Detection</MenuItem>
          </Link>
          <Link to="/digital-assays/assays-create/cnd">
            <MenuItem onClick={this.handleClose}>
              Copy Number Determination
            </MenuItem>
          </Link>
          <Link to="/digital-assays/assays-create/genome">
            <MenuItem onClick={this.handleClose}>
              Genome Edit Detection
            </MenuItem>
          </Link>
          <Link to="/digital-assays/assays-create/gene-expression">
            <MenuItem onClick={this.handleClose}>Gene Expression</MenuItem>
          </Link>
          <Link to="/digital-assays/assays-create/cell-and-gene-therapy">
            <MenuItem onClick={this.handleClose}>
              Cell and Gene Therapy
            </MenuItem>
          </Link>
        </Menu>
      </div>
    );
  }
}

MyAssaysForm.propTypes = {
  actions: PropTypes.object,
  change: PropTypes.object,
};

const MyAssays = () => {
  return (
    <AppWrapper
      id="my-assays"
      pageTitle="My Assays"
      pageKeywords="My Assays, custom assays, assay ID"
      pageDescription="The My Assays page displays your list of custom assays."
    >
      <div className="container main-content">
        <div className="row">
          <div className="col">
            <h1>My Assays</h1>
          </div>
          <div className="col">
            <div className="float-right">
              <AssayMenu />
            </div>
          </div>
        </div>
        <MyAssaysForm />
      </div>
    </AppWrapper>
  );
};

export default MyAssays;

PendingAssays.propTypes = {
  pendingAssays: PropTypes.array,
  classes: PropTypes.object,
};

EnhancedTableHead.propTypes = {
  actions: PropTypes.object,
  onRequestSort: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  columnData: PropTypes.array.isRequired,
};
